export default {
    finalize() {
        const self = this

        $('.filter-item').click(function () {
            let filters = []

            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
            } else {
                $(this).addClass('active')
            }

            $('.filter-item').each(function () {
                if ($(this).hasClass('active')) {
                    filters.push($(this).data('term'))
                }
            });

            self.filter(filters);

        });
    },
    filter(filters) {
        let pdf = $('.pdf');

        pdf.each(function () {
            const self = $(this);
            const classes = self.attr('class');

            if (filters.every(item => classes.includes(item))) {
                self.show()
            } else {
                self.hide()
            }
        })
    },
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/web/app/themes/main-theme/resources/assets/scripts/routes/case-studies.js